export enum ERouteKey {
  // Suffix
  NAVIGATE = "NAVIGATE",
  // end Suffix

  OUTLET = "OUTLET",

  DELIVERY = "DELIVERY",
  DELIVERY_ROUTE_PLANNING = "DELIVERY_ROUTE_PLANNING",
  TRANSPORT_ROUTE_PLANNING_PILOT = "TRANSPORT_ROUTE_PLANNING_PILOT",
  OSRM_ROUTE_SYNC_REVIEW = "OSRM_ROUTE_SYNC_REVIEW",
  OSRM_ROUTE_SYNC_REVIEW_LEGACY_REDIRECT = "OSRM_ROUTE_SYNC_REVIEW_LEGACY_REDIRECT",
  LINE_TRANSPORT_MANAGEMENT = "LINE_TRANSPORT_MANAGEMENT",
  LINE_TRANSPORT_MANAGEMENT_LEGACY_REDIRECT = "LINE_TRANSPORT_MANAGEMENT_LEGACY_REDIRECT",
  LINE_TRANSPORT_CHAT_ARCHIVE = "LINE_TRANSPORT_CHAT_ARCHIVE",
  EPOD_APP_OPERATIONS = "EPOD_APP_OPERATIONS",
  DRIVER_MANUAL = "DRIVER_MANUAL",
  DRIVER_MANAGEMENT = "DRIVER_MANAGEMENT",

  SITEMAP = "SITEMAP",

  BASE = "BASE",

  UIDEV = "UIDEV",

  BUYER_LIST = "BUYER_LIST",

  FARMBOOK_LOGIN = "FARMBOOK_LOGIN",
  LOGIN = "LOGIN",
  PRIVACY = "PRIVACY",

  DASHBOARD = "DASHBOARD",
  WELCOME = "WELCOME",

  MEMBERS_OUTLET = "MEMBERS_OUTLET",
  MEMBER_REGISTER = "MEMBERS_REGISTER",
  MEMBER_SUBSCRIBE = "MEMBER_SUBSCRIBE",
  MEMBER_BUYER = "MEMBER_BUYER",
  MEMBER_SELLER = "MEMBER_SELLER",
  MEMBER_NEWS_LETTER = "MEMBER_NEWS_LETTER",

  FINANCE_OUTLET = "FINANCE_OUTLET",
  FINANCE_BUY_SELL = "FINANCE_BUY_SELL",
  FINANCE_FINANCE_INFO = "FINANCE_FINANCE_INFO",

  HELPDESK_SUPPORT_OUTLET = "HELPDESK_SUPPORT_OUTLET",
  HELPDESK_SUPPORT_COMPLAINTS = "HELPDESK_SUPPORT_COMPLAINTS",
  HELPDESK_SUPPORT_HELOPDESK_SETTING = "HELPDESK_SUPPORT_HELOPDESK_SETTING",

  REPORTS_OUTLET = "REPORTS_OUTLET",
  REPORT_BUYER = "REPORT_BUYER",
  PUNTHAI = "PUNTHAI",
  REPORT_PUNTHAI = "REPORT_PUNTHAI",
  REPORT_PUNTHAI_DETAIL = "REPORT_PUNTHAI_DETAIL",
  REPORT_STORE = "REPORT_STORE",
  REPORT_PRODUCT = "REPORT_PRODUCT",

  PRODUCT_SALES = "PRODUCT_SALES",
  PRODUCT_OUTLET = "PRODUCT_OUTLET",
  PRODUCT_LIST = "PRODUCT_LIST",
  PRODUCT_LIST_LINE = "PRODUCT_LIST_LINE",
  PRODUCT_LIST_LINE_CREATE = "PRODUCT_LIST_LINE_CREATE",
  PRODUCT_LIST_LINE_EDIT = "PRODUCT_LIST_LINE_EDIT",
  PACKAGING_MANAGEMENT = "PACKAGING_MANAGEMENT",
  ORDERS_LINE = "ORDERS_LINE",
  ORDERS_LINE_RETURN = "ORDERS_LINE_RETURN",
  CLAIM_MANAGEMENT = "CLAIM_MANAGEMENT",

  INVOICE = "INVOICE",

  WAREHOUSE_OUTLET = "WAREHOUSE_OUTLET",
  WAREHOUSE_OUTLET_NAVIGATE = "WAREHOUSE_OUTLET_NAVIGATE",
  WAREHOUSE_INFORMATION_OUTLET = "WAREHOUSE_INFORMATION_OUTLET",
  WAREHOUSE_INFORMATION = "WAREHOUSE_INFORMATION",
  WAREHOUSE_INFORMATION_CREATE = "WAREHOUSE_INFORMATION_CREATE",
  WAREHOUSE_INFORMATION_BY_UUID = "WAREHOUSE_INFORMATION_BY_UUID",
  WAREHOUSE_ORDERS = "WAREHOUSE_ORDERS",
  WAREHOUSE_ORDERS_OUTLET = "WAREHOUSE_ORDERS_OUTLET",
  WAREHOUSE_ORDERS_DETAIL_OUTLET = "WAREHOUSE_ORDERS_DETAIL_OUTLET",
  WAREHOUSE_ORDERS_DETAIL = "WAREHOUSE_ORDERS_DETAIL",
  WAREHOUSE_ORDERS_DETAIL_ORDER_ID = "WAREHOUSE_ORDERS_DETAIL_ORDER_ID",
  WAREHOUSE_ORDERS_DETAIL_PRODUCT_DETAIL_OUTLET = "WAREHOUSE_ORDERS_DETAIL_PRODUCT_DETAIL_OUTLET",
  WAREHOUSE_ORDERS_DETAIL_PRODUCT_DETAIL_PRODUCT_ID = "WAREHOUSE_ORDERS_DETAIL_PRODUCT_DETAIL_PRODUCT_ID",

  PURCHASE_OUTLET = "PURCHASE_OUTLET",
  PURCHASE_LIST_OUTLET = "PURCHASE_LIST_OUTLET",
  PURCHASE_LIST = "PURCHASE_LIST",
  PURCHASE_LIST_DETAIL_OUTLET = "PURCHASE_LIST_DETAIL_OUTLET",
  PURCHASE_LIST_DETAIL_OUTLET_NAVIGATE = "PURCHASE_LIST_DETAIL_OUTLET_NAVIGATE",
  PURCHASE_LIST_DETAIL_ID = "PURCHASE_LIST_DETAIL_ID",
  PURCHASE_DETAIL = "PURCHASE_LIST",
  PURCHASE_ORDERS_OUTLET = "PURCHASE_ORDERS_OUTLET",
  PURCHASE_BUYING = "PURCHASE_BUYING",
  PURCHASE_BUYING_OUTLET = "PURCHASE_BUYING_OUTLET",
  PURCHASE_BUYING_DETAIL_OUTLET = "PURCHASE_BUYING_DETAIL_OUTLET",
  PURCHASE_BUYING_DETAIL_ID = "PURCHASE_BUYING_DETAIL_ID",
  PURCHASE_BUYING_OUTLET_NAVIGATE = "PURCHASE_BUYING_OUTLET_NAVIGATE",
  PURCHASE_ORDERS = "PURCHASE_ORDERS",
  PURCHASE_ORDERS_COPY = "PURCHASE_ORDERS_COPY",
  PURCHASE_ORDERS_DETAIL_OUTLET = "PURCHASE_ORDERS_DETAIL_OUTLET",
  PURCHASE_ORDERS_DETAIL_OUTLET_NAVIGATE = "PURCHASE_ORDERS_DETAIL_OUTLET_NAVIGATE",

  WEBDATA_OUTLET = "WEBDATA_OUTLET",
  BANNER_HOMEPAGE_LIST = "BANNER_HOMEPAGE_LIST",
  BANNER_HOMEPAGE_LIST_OUTLET = "BANNER_HOMEPAGE_LIST_OUTLET",
  BANNER_HOMEPAGE_LIST_CREATE = "BANNER_HOMEPAGE_LIST_CREATE",
  BANNER_HOMEPAGE_LIST_EDIT = "BANNER_HOMEPAGE_LIST_EDIT",
  BANNER_GREETING_MODAL_LIST = "BANNER_GREETING_MODAL_LIST",
  BANNER_GREETING_MODAL_LIST_OUTLET = "BANNER_HOMEPAGE_LIST_OUTLET",
  BANNER_GREETING_MODAL_LIST_CREATE = "BANNER_HOMEPAGE_LIST_CREATE",
  BANNER_GREETING_MODAL_LIST_EDIT = "BANNER_HOMEPAGE_LIST_EDIT",

  SETTING_OUTLET = "SETTING_OUTLET",
  SETUP_CATEGORIES = "SETUP_CATEGORIES",
  SETUP_SHORTCUTS = "SETUP_SHORTCUTS",

  SETTING_OUTLET_NAVIGATE = "SETTING_OUTLET_NAVIGATE",
  SETTING_OUTLET_DEFAULT = "SETTING_OUTLET_DEFAULT",
  SETTING_ACCESS = "SETTING_ACCESS",
  SETTING_ACCESS_DEFAULT = "SETTING_ACCESS_DEFAULT",
  SETTING_ACCESS_USER = "SETTING_ACCESS_USER",
  SETTING_ACCESS_USER_GROUP = "SETTING_ACCESS_USER_GROUP",
  SETTING_BUSINESS = "SETTING_BUSINESS",
  SETTING_AI = "SETTING_AI",
  SETTING_DELIVERY_INTEGRATION = "SETTING_DELIVERY_INTEGRATION",
  SETTING_EPOD_GEOFENCE = "SETTING_EPOD_GEOFENCE",
  SETTING_APP_OPERATIONS = "SETTING_APP_OPERATIONS",
  SETTING_APP_OPERATIONS_DEFAULT = "SETTING_APP_OPERATIONS_DEFAULT",
  SETTING_SESSION_MANAGEMENT = "SETTING_SESSION_MANAGEMENT",
  SETTING_SESSION_MANAGEMENT_LEGACY_REDIRECT = "SETTING_SESSION_MANAGEMENT_LEGACY_REDIRECT",
  SETTING_EPOD_APP_OPERATIONS_LEGACY_REDIRECT = "SETTING_EPOD_APP_OPERATIONS_LEGACY_REDIRECT",
  SETTING_PACKAGING = "SETTING_PACKAGING",
  SETTING_PRODUCT_CATEGORY = "SETTING_PRODUCT_CATEGORY",
  SETTING_PRODUCT_UNIT = "SETTING_PRODUCT_UNIT",
  SETTING_PRODUCT_SHIPPING_OUTLET = "SETTING_PRODUCT_SHIPPING_OUTLET",
  SETTING_PRODUCT_SHIPPING = "SETTING_PRODUCT_SHIPPING",
  SETTING_PRODUCT_SHIPPING_CREATE = "SETTING_PRODUCT_SHIPPING_CREATE",
  SETTING_PRODUCT_SHIPPING_EDIT = "SETTING_PRODUCT_SHIPPING",
  SETTING_ENVIRONMENT_BADGE_DEMO = "SETTING_ENVIRONMENT_BADGE_DEMO",
  EPOD_APP_OPERATIONS_LEGACY_REDIRECT = "EPOD_APP_OPERATIONS_LEGACY_REDIRECT",

  USER_BRANCH_MANAGEMENT = "USER_BRANCH_MANAGEMENT",

  // Multi-Franchise Management Routes
  FRANCHISE_MANAGEMENT = "FRANCHISE_MANAGEMENT",

  // Customer Drop Management Routes
  CUSTOMER_DROP_MANAGEMENT = "CUSTOMER_DROP_MANAGEMENT",

  // Excel Route Management Routes
  EXCEL_ROUTE_MANAGEMENT = "EXCEL_ROUTE_MANAGEMENT",
  EXCEL_ROUTE_EXPORT_ORDERS = "EXCEL_ROUTE_EXPORT_ORDERS",
  EXCEL_ROUTE_IMPORT_ROUTES = "EXCEL_ROUTE_IMPORT_ROUTES",
  OSRM_CONTROL_SHEET_IMPORT = "OSRM_CONTROL_SHEET_IMPORT",

  // Netbay SFTP Upload Management
  NETBAY_SFTP_UPLOAD = "NETBAY_SFTP_UPLOAD",

  // Netbay PDF → Google Drive Upload Management
  NETBAY_PDF_UPLOAD = "NETBAY_PDF_UPLOAD",

  // Billing PDF Generator
  BILLING_PDF_GENERATOR = "BILLING_PDF_GENERATOR",

  // Super Admin Routes
  SUPER_ADMIN_OUTLET = "SUPER_ADMIN_OUTLET",
  SUPER_ADMIN_DATA_MANAGEMENT = "SUPER_ADMIN_DATA_MANAGEMENT",

  NOT_FOUND = "NOT_FOUND",

  CUSTOMER_MANAGEMENT = "CUSTOMER_MANAGEMENT",

  // Line Chat History Routes
  LINE_CHAT_HISTORY = "LINE_CHAT_HISTORY",
  SUPPORT_TICKET_HELPDESK = "SUPPORT_TICKET_HELPDESK",
  SMS_OTP_LOGS = "SMS_OTP_LOGS",
  SMS_OTP_LOGS_LEGACY_REDIRECT = "SMS_OTP_LOGS_LEGACY_REDIRECT",

  // Customer Order Portal Routes
  CUSTOMER_PORTAL_OUTLET = "CUSTOMER_PORTAL_OUTLET",
  CUSTOMER_PORTAL_INVOICE_LIST = "CUSTOMER_PORTAL_INVOICE_LIST",
  CUSTOMER_PORTAL_BILLING_INVOICES = "CUSTOMER_PORTAL_BILLING_INVOICES",

  // Promotion Management
  PROMOTION_MANAGEMENT = "PROMOTION_MANAGEMENT",

  // Broadcast Management
  BROADCAST = "BROADCAST",
  BROADCAST_CENTER = "BROADCAST_CENTER",
  ORDER_REMINDER = "ORDER_REMINDER",

  // Outstanding Orders / Discrepancy Management
  OUTSTANDING_ORDERS = "OUTSTANDING_ORDERS",

  // Billing Cycle Template Management
  SETTING_BILLING_CYCLE_TEMPLATE = "SETTING_BILLING_CYCLE_TEMPLATE",

  // No Permission Fallback
  NO_PERMISSION = "NO_PERMISSION",
}
